import Modal from "@via/components/modal.tsx";
import ActivityRunList from "@via/pages/activity/activity-run-list";
import { ModalSize } from "@via/utils/constants";

type ExistingRunsModalProps = {
  open: boolean;
  setOpen: (open: boolean) => void;
  pipelineId: string | undefined;
};

const ExistingRunsModal: React.FC<ExistingRunsModalProps> = ({
  open,
  setOpen,
  pipelineId,
}) => {
  return (
    <Modal
      open={open}
      setOpen={setOpen}
      title="Existing Runs"
      size={ModalSize.Large}>
      <ActivityRunList pipelineId={pipelineId} />
    </Modal>
  );
};
export default ExistingRunsModal;
